<template>
  <base-overlay :show="fetching">
    <b-card>
      <validation-observer ref="createRef">
        <b-form @submit.prevent="submit">
          <b-row>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                name="Title"
                rules="required"
              >
                <b-form-group
                  label="Title"
                  label-for="title"
                >
                  <b-form-input
                    id="title"
                    v-model="formData.title"
                  />
                  <span class="text-danger"> {{ errors[0] }} </span>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                name="Title Arabic"
                rules="required"
              >
                <b-form-group
                  label="Title Arabic"
                  label-for="title-ar"
                >
                  <b-form-input
                    id="title-ar"
                    v-model="formData.title_ar"
                  />
                  <span class="text-danger"> {{ errors[0] }} </span>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                name="Description"
                rules="required"
              >
                <b-form-group
                  label="Description"
                  label-for="description"
                >
                  <b-form-textarea
                    id="description"
                    v-model="formData.description"
                  />
                  <span class="text-danger"> {{ errors[0] }} </span>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                name="Description Arabic"
                rules="required"
              >
                <b-form-group
                  label="Description Arabic"
                  label-for="description-ar"
                >
                  <b-form-textarea
                    id="description-ar"
                    v-model="formData.description_ar"
                  />
                  <span class="text-danger"> {{ errors[0] }} </span>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                name="Sort Order"
                rules="required"
              >
                <b-form-group
                  label="Sort Order"
                  label-for="sort-order"
                >
                  <b-form-input
                    id="sort-order"
                    v-model.number="formData.sort_order"
                    type="number"
                  />
                  <span class="text-danger"> {{ errors[0] }} </span>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                name="Video"
                :rules="isNew ? 'required' : ''"
              >
                <b-form-group
                  label="Video"
                  label-for="video"
                >
                  <b-form-file
                    v-model="uploadedFile"
                    accept=".mp4"
                  />
                  <span class="text-danger"> {{ errors[0] }} </span>
                  <template v-if="cachedLearning && !isNew">
                    <small
                      v-if="cachedLearning.metadata.video_name"
                      class="text-warning"
                    >Previous video: {{ cachedLearning.metadata.video_name }}</small>
                    <div
                      v-if="cachedLearning.metadata.read_url"
                      :style="{
                        height: '300px'
                      }"
                    >
                      <video
                        :style="{
                          'min-width':'100%',
                          'max-width':'100%',
                          'max-height': '100%',
                          'object-fit': 'cover'
                        }"
                        controls
                        autoplay
                        muted
                        :src="cachedLearning.metadata.read_url"
                      />
                    </div>
                  </template>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              md="6"
            >
              <b-button
                :disabled="submitting"
                variant="primary"
                type="submit"
              >
                <template
                  v-if="submitting"
                >
                  <b-spinner
                    class="mr-1"
                    small
                  />
                  <span>Submitting, Might take a while..</span>
                </template>
                <span v-else>Submit</span>
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>

    </b-card>

  </base-overlay>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import {
  BCard, BRow, BCol, BFormGroup, BFormInput, BForm, BFormTextarea, BButton, BSpinner, BFormFile,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import axios from 'axios'
import BaseOverlay from '@/UI/BaseOverlay.vue'
import { errorNotification } from '@/utils/toast-notifications'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import store from '../driverStoreModule'

export default {
  components: {
    BRow,
    BFormGroup,
    BFormInput,
    BFormFile,
    BButton,
    BFormTextarea,
    BForm,
    BSpinner,
    BCol,
    ValidationProvider,
    ValidationObserver,
    BaseOverlay,
    BCard,
  },
  props: {
    isNew: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, ctx) {
    const learningID = ctx.root.$route.params.id
    useRegisterStoreModule('drivers', store)

    const cachedLearning = ref()

    const formData = ref({
      title: '',
      title_ar: '',
      description: '',
      description_ar: '',
      sort_order: null,
      metadata: {},
    })
    const uploadedFile = ref()

    const uploadVideoHandler = async learningId => {
      const retrieveResult = await ctx.root.$store.dispatch('drivers/getLearning', {
        learningId,
        params: {
          action: 'upload_media',
        },
      })
      const { url, key } = retrieveResult.data.data
      await axios.put(url, uploadedFile.value)
      return key
    }
    const submitting = ref(false)
    const submit = async () => {
      const res = await ctx.refs.createRef.validate()
      if (!res) return

      try {
        submitting.value = true

        if (props.isNew) {
          const creationResult = await ctx.root.$store.dispatch('drivers/createLearning', formData.value)
          const { id } = creationResult.data.data
          const key = await uploadVideoHandler(id)
          await ctx.root.$store.dispatch('drivers/updateLearning', {
            payload: {
              metadata: {
                key,
                video_name: uploadedFile.value.name,
                video_size: uploadedFile.value.size,
              },
            },
            learningId: id,
          })
        } else {
          const temp = {}
          if (formData.value.title !== cachedLearning.value.title) temp.title = formData.value.title
          if (formData.value.title_ar !== cachedLearning.value.title_ar) temp.title_ar = formData.value.title_ar
          if (formData.value.description !== cachedLearning.value.description) temp.description = formData.value.description
          if (formData.value.description_ar !== cachedLearning.value.description_ar) temp.description_ar = formData.value.description_ar
          if (formData.value.sort_order !== cachedLearning.value.sort_order) temp.sort_order = formData.value.sort_order

          if (uploadedFile.value) {
            const key = await uploadVideoHandler(learningID)
            temp.metadata = {
              key,
              video_name: uploadedFile.value.name,
              video_size: uploadedFile.value.size,
            }
          }
          if (Object.keys(temp).length === 0) {
            errorNotification('Nothing is edited yet..')
            return
          }
          await ctx.root.$store.dispatch('drivers/updateLearning', {
            payload: temp,
            learningId: learningID,
          })
        }
        ctx.root.$router.push('/drivers/learning-center')
      } catch (err) {
        console.log(err)

        if (err?.response) {
          const obj = err.response.data.error
          const firstErr = Object.keys(err.response.data.error)[0]
          errorNotification(obj[firstErr][0])
        } else {
          errorNotification('Error...')
        }
      } finally {
        submitting.value = false
      }
    }

    const fetching = ref(false)

    const fetchOne = async () => {
      fetching.value = true
      const result = await ctx.root.$store.dispatch('drivers/getLearning', {
        learningId: learningID,
      })
      const { data } = result.data
      cachedLearning.value = JSON.parse(JSON.stringify(data))
      formData.value = JSON.parse(JSON.stringify(data))
      fetching.value = false
    }
    if (!props.isNew && learningID) {
      fetchOne()
    }
    return {
      required,
      formData,
      submitting,
      fetching,
      cachedLearning,
      uploadedFile,
      submit,
    }
  },
}
</script>
